'use strict';
/**
 * Contributions VEF module
 */
angular.module('contributions-vef', ['contributions-vef.components']);

angular.module('contributions-vef.components', []);
